function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createPlugin } from '@fullcalendar/core/index.js';
import premiumCommonPlugin from '@fullcalendar/premium-common/index.js';
import { config, removeExact, findElements, injectStyles } from '@fullcalendar/core/internal.js';
import { flushSync } from '@fullcalendar/core/preact.js';
config.COLLAPSIBLE_WIDTH_THRESHOLD = 1200;
var contexts = [];
var undoFuncs = [];

function contextInit(context) {
  if (!contexts.length) {
    attachGlobalHandlers();
  }

  contexts.push(context);
  context.calendarApi.on('_unmount', function () {
    removeExact(contexts, context);

    if (!contexts.length) {
      removeGlobalHandlers();
    }
  });
}

function attachGlobalHandlers() {
  window.addEventListener('beforeprint', handleBeforePrint);
  window.addEventListener('afterprint', handleAfterPrint); // // for testing
  // let forPrint = false
  // document.addEventListener('keypress', (ev) => {
  //   if (ev.key === 'p') {
  //     forPrint = !forPrint
  //     if (forPrint) {
  //       handleBeforePrint()
  //     } else {
  //       handleAfterPrint()
  //     }
  //   }
  // })
}

function removeGlobalHandlers() {
  window.removeEventListener('beforeprint', handleBeforePrint);
  window.removeEventListener('afterprint', handleAfterPrint);
}

function handleBeforePrint() {
  var _iterator = _createForOfIteratorHelper(contexts),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var context = _step.value;
      context.emitter.trigger('_beforeprint');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  flushSync(function () {
    undoFuncs.push(freezeScrollgridWidths());
  });
}

function handleAfterPrint() {
  var _iterator2 = _createForOfIteratorHelper(contexts),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var context = _step2.value;
      context.emitter.trigger('_afterprint');
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  flushSync(function () {
    while (undoFuncs.length) {
      undoFuncs.shift()();
    }
  });
} // scrollgrid widths


function freezeScrollgridWidths() {
  var els = findElements(document.body, '.fc-scrollgrid');
  els.forEach(freezeScrollGridWidth);
  return function () {
    return els.forEach(unfreezeScrollGridWidth);
  };
}

function freezeScrollGridWidth(el) {
  var elWidth = el.getBoundingClientRect().width; // along with collapsibleWidth, this is a hack for #5707

  if (!el.classList.contains('fc-scrollgrid-collapsible') || elWidth < config.COLLAPSIBLE_WIDTH_THRESHOLD) {
    el.style.width = elWidth + 'px';
  }
}

function unfreezeScrollGridWidth(el) {
  el.style.width = '';
}

var css_248z = ".fc .fc-event,.fc .fc-scrollgrid table tr{-moz-column-break-inside:avoid;break-inside:avoid}.fc-media-print{display:block;max-width:100%}.fc-media-print .fc-bg-event,.fc-media-print .fc-non-business,.fc-media-print .fc-timegrid-axis-chunk,.fc-media-print .fc-timegrid-slots,.fc-media-print .fc-timeline-slots{display:none}.fc-media-print .fc-h-event,.fc-media-print .fc-toolbar button,.fc-media-print .fc-v-event{background:#fff!important;color:#000!important}.fc-media-print .fc-event,.fc-media-print .fc-event-main{color:#000!important}.fc-media-print .fc-timegrid-event{margin:.5em 0}";
injectStyles(css_248z);
var index = createPlugin({
  name: '@fullcalendar/adaptive',
  premiumReleaseDate: '2023-11-29',
  deps: [premiumCommonPlugin],
  contextInit: contextInit
});
export { index as default };